export default {
      id: "Icon--addArea-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--addArea",
      toString: function () {
        return this.url;
      }
    }